import PropTypes from "prop-types";
import clsx from "clsx";
import { Link } from "react-router-dom";
import FooterCopyright from "../../components/footer/FooterCopyright";
import { useStoreInfo } from "../../hooks/storeInfoHooks/useStoreInfo";
import { t } from "i18next";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const FooterOne = ({
  backgroundColorClass,
  spaceTopClass,
  spaceBottomClass,
  spaceLeftClass,
  spaceRightClass,
  containerClass,
  extraFooterClass,
  sideMenu,
}) => {
  const { data: storeInfo, isLoading: isLoadingStoreInfo } = useStoreInfo();

  const activeSocialMedia =
    storeInfo?.[0]?.social_media?.filter((sm) => sm.status) || [];

  return (
    <footer
      className={clsx(
        "footer-area rounded-top-5",
        backgroundColorClass,
        spaceTopClass,
        spaceBottomClass,
        extraFooterClass,
        spaceLeftClass,
        spaceRightClass
      )}
      // style={{
      //   boxShadow: "0px 0px 30px 10px rgba(0, 0, 0, 0.2)",
      //   borderTop: "1px solid #ca1818",
      // }}
    >
      <div className={`${containerClass ? containerClass : "container-fluid"}`}>
        <div className="row">
          <div
            className={`text-center ${
              sideMenu ? "col-xl-3 col-sm-4" : "col-lg-3 col-sm-4"
            }`}
          >
            {/* footer copyright */}
            {isLoadingStoreInfo && (
              <>
                <Skeleton height={"50px"} width={"100px"} />
                <Skeleton height={"15px"} width={"200px"} count={2} />
              </>
            )}
            <FooterCopyright
              footerLogo={`${import.meta.env.VITE_REACT_APP_API_URL}/${
                storeInfo?.[0]?.logo
              }`}
              spaceBottomClass="mb-30"
              title={storeInfo?.[0]?.name}
              description={storeInfo?.[0]?.description}
            />
          </div>
          <div
            className={`${
              sideMenu ? "col-xl-3 col-sm-4 col-6" : "col-lg-3 col-sm-4 col-6"
            }`}
          >
            <div className="footer-widget mb-30 ml-30">
              <div className="footer-title">
                <h3 className="fw-bold">{t("shop")}</h3>
              </div>
              <div className="footer-list">
                <ul>
                  <li className="fw-medium">
                    <Link to="/">{t("home")}</Link>
                  </li>
                  <li className="fw-medium">
                    <Link to="/shop">{t("shop")}</Link>
                  </li>
                  <li className="fw-medium">
                    <Link to="/cart">{t("cart")}</Link>
                  </li>
                  <li className="fw-medium">
                    <Link to="/wishlist">{t("wishlist")}</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            className={`${
              sideMenu ? "col-xl-3 col-sm-4 col-6" : "col-lg-3 col-sm-4 col-6"
            }`}
          >
            <div
              className={`${
                sideMenu
                  ? "footer-widget mb-30 ml-95"
                  : "footer-widget mb-30 ml-50"
              }`}
            >
              <div className="footer-title">
                <h3 className="fw-bold">{t("important_links")}</h3>
              </div>
              <div className="footer-list">
                <ul>
                  <li className="fw-medium">
                    <Link to="/about">{t("about")}</Link>
                  </li>
                  <li className="fw-medium">
                    <Link to="/contact">{t("contact")}</Link>
                  </li>
                  <li className="fw-medium">
                    <Link to="/privacy-policy">{t("privacy_policy")}</Link>
                  </li>
                  <li className="fw-medium">
                    <Link to="/shipping-info">{t("shipping_info")}</Link>
                  </li>
                  <li className="fw-medium">
                    <Link to="/return-policy">{t("return_policy")}</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            className={`${
              sideMenu ? "col-xl-3 col-sm-4" : "col-lg-3 col-sm-6"
            }`}
          >
            <div
              className={`${
                sideMenu
                  ? "footer-widget mb-30 ml-145"
                  : "footer-widget mb-30 ml-75"
              }`}
            >
              <div className="footer-title">
                <h3 className="fw-bold">{t("contact")}</h3>
              </div>
              <div className="footer-list">
                <ul>
                  <li>
                    <a
                      href={`tel:${storeInfo?.[0]?.phone}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-flex align-items-center gap-2"
                    >
                      <i className="fa fa-phone fs-5"></i>
                      {isLoadingStoreInfo && (
                        <Skeleton height={"15px"} width={"130px"} count={1} />
                      )}
                      {storeInfo?.[0]?.phone}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`mailto:${storeInfo?.[0]?.email}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-flex align-items-center gap-2"
                    >
                      <i className="fa fa-envelope fs-5"></i>
                      {isLoadingStoreInfo && (
                        <Skeleton height={"15px"} width={"130px"} count={1} />
                      )}
                      {storeInfo?.[0]?.email}
                    </a>
                  </li>
                  <li>
                    <a
                      href={``}
                      className="d-flex align-items-start gap-2"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-map-marker fs-4"></i>
                      {isLoadingStoreInfo && (
                        <Skeleton height={"15px"} width={"130px"} count={1} />
                      )}
                      {storeInfo?.[0]?.address}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container ">
          <div
            className={clsx(
              "copyright-2  mt-0 d-flex justify-content-sm-between justify-content-center align-items-center py-3 flex-wrap gap-2"
            )}
          >
            <p className="text-black mb-0 fw-medium">
              {isLoadingStoreInfo && (
                <Skeleton height={"15px"} width={"200px"} count={1} />
              )}
              {storeInfo?.[0]?.footer_text}
            </p>
            <div className="d-flex align-items-center gap-3 footer-list">
              {activeSocialMedia.map((social) => {
                return (
                  <a
                    key={social.name}
                    href={social.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={`${import.meta.env.VITE_REACT_APP_API_URL}/${
                        social.icon
                      }`}
                      alt={social.name}
                      style={{ width: "20px", height: "20px" }}
                    />
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

FooterOne.propTypes = {
  backgroundColorClass: PropTypes.string,
  containerClass: PropTypes.string,
  extraFooterClass: PropTypes.string,
  sideMenu: PropTypes.bool,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
  spaceLeftClass: PropTypes.string,
  spaceRightClass: PropTypes.string,
};

export default FooterOne;
